import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { voicesTypeControl } from '../../../types/audioType';
import { panel_1, sub2_act3_01, sub2_act3_02, sub2_act3_03, sub2_act3_04, sub2_act3_05, sub2_act3_06, sub2_act3_07, sub2_act3_08 } from '../../../assets/tema8';
import { PanelInstrucionHands } from '../../../components/common/PanelInstrucionHands';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	win: 14
};


const stepThree = {
	move_gondola_1: {
		ui: steps.dialogFour,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a03)
		}
	},
	move_floor: {
		ui: steps.dialogFive,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a04)
		}
	},
	move_door_1: {
		ui: steps.dialogSix,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a05)
		}
	},
	move_door_2: {
		ui: steps.dialogSeven,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a06)
		}
	},
	move_desk_1: {
		ui: steps.dialogEight,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a07)
		}
	},
	move_cel_1: {
		ui: steps.dialogNine,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a08)
		}
	},
	move_fraudes_1: {
		ui: steps.dialogTen,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a09)
		}
	},
	move_desk_2: {
		ui: steps.dialogEleven,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a10)
		}
	},
	move_init: {
		ui: steps.dialogTwelve,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a11)
		}
	},
}

export const Theme8SubtopicTwoActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema8.activities.subtema2], 3);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 8 sub 2 act 3");
			ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a01)
	})

	ObserverEmitter.on(EVENTS.tema8.topic2.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 3);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 1: Regla de Oro.' />
					<DialogBarNew
						dialog={`Otras formas de atraco son: farderos, pisa y corre o robo por ventanilla.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Situaciones de riesgo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad3.sub2a3a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`A continuación, identificarás las diferentes formas de robo, que incluyen a los farderos, pisa y corre, y el robo por ventanilla, entre otros dentro de tu tienda.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<PanelInstrucionHands
						action={() => {
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_gondola_1")
							setUiToShow(-1);
						}}
						img={panel_1}
						text='Toca encima del lugar iluminado para obtener más información. '
					/>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<ViewPerson img={sub2_act3_01} />
					<DialogBarNew
						dialog={`Farderísmo: Guardan mercancía entre su ropa y buscan no ser descubiertos por el personal de tienda. En ocasiones un cómplice entra para distraer y así lograr el robo de producto.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_floor")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<ViewPerson img={sub2_act3_02} />
					<DialogBarNew
						dialog={`Pisa y corre: El ladrón asiste a tienda, toma mercancía sin decir nada y huye.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_door_1")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<ViewPerson img={sub2_act3_03} />
					<DialogBarNew
						dialog={`Robo por ventanilla: Solicitan al empleado mercancía por ventanilla y huyen sin pagar.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_door_2")
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<ViewPerson img={sub2_act3_04} />
					<DialogBarNew
						dialog={`Asalto: El asaltante solicita al empleado el efectivo que tenga en la caja y productos de alto valor como cigarros, vinos y licores.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_desk_1")
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<ViewPerson img={sub2_act3_05} />
					<DialogBarNew
						dialog={`Corresponsalías forzadas: Asaltantes solicitan al empleado realizar depósitos a diferentes cuentas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_cel_1")
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<ViewPerson img={sub2_act3_06} />
					<DialogBarNew
						dialog={`Extorsiones: A través de llamadas o mensajes los delincuentes intimidan a las víctimas creando escenarios de riesgo y amenazas de daño físico o patrimonial para obtener un beneficio económico.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_fraudes_1")
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<ViewPerson img={sub2_act3_07} />
					<DialogBarNew
						dialog={`Fraudes: Son practicas ilegales realizadas por un colaborador para beneficio propio y reflejadas como un faltante para la empresa, por ejemplo, el robo de efectivo por mercancía, no registro de ventas en Tienda, disposición de efectivo de ventas y trabajos no realizados.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_desk_2")
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<ViewPerson img={sub2_act3_08} />
					<DialogBarNew
						dialog={`Agresiones: Cualquier conducta cuyo objetivo es causar un daño a la persona por medio de la agresión verbal, física o sexual, como por ejemplo: agresiones hacia el personal de tienda por parte de clientes, agresiones hacia los clientes por parte del personal de tienda o agresiones entre clientes.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene, "move_init")
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwelve && (
				<>
					<DialogBarNew
						dialog={`Ten presente que puedes contar con nosotros ante casos de agresiones física o sexuales, tanto por Colaboradores como personas externas a la Empresa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema8.topic2.actScene)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Ahora conoces sobre situaciones de riesgo, asegurando tu seguridad en cualquier circunstancia."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: 0,
									subtema: tasksId.tema8.activities.subtema2
								})
							);
							navigator("/home8/tema8/subtema2/activityFour");
						}}
					/>
				</>
			)}
		</>
	)
}

const ViewPerson = ({ img = "" }) => {
	return (
		<>
			<div className='fixed h-full w-full bg-[#00000074] flex justify-center items-center'>
				<div className='w-[250px] h-[250px] md:w-[500px] md:h-[500px]'>
					<img className='h-full w-full object-contain' src={img} alt="person" />
				</div>
			</div>
		</>
	)
}